import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { SpsTab } from "@spscommerce/ds-shared";

@Component({
    selector: "sps-tabs",
    templateUrl: "./sps-tabs.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated
})
export class SpsTabsComponent implements OnInit {
    @HostBinding("class.sps-tabs") readonly _spsTabsClass = true;

    @Input() tabs: SpsTab[];
    @Input() activeTab: SpsTab;
    @Output() tabChange = new EventEmitter<SpsTab>();

    _onTabClick(event: MouseEvent, tab: SpsTab) {
        event.preventDefault();
        this.activeTab = tab;
        this.tabChange.emit(tab);
    }

    _onKeyDown(event: KeyboardEvent, tab: SpsTab) {
        if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
            event.preventDefault();
            this.activeTab = tab;
            this.tabChange.emit(tab);
        }
    }

    ngOnInit() {
        if (!this.activeTab && this.tabs && this.tabs.length) {
            this.activeTab = this.tabs[0];
        }
    }
}
